<template>
  <v-app class="app-dashboard" grid-list-md>
    <v-layout wrap :fill-height="false" style="margin-right: 2%">
      <v-flex xs7 class="div-main-chart">
        <v-card class="card-chart">
          <NewChart style="height: 100%" />
        </v-card>
      </v-flex>

      <v-flex xs5>
        <Cards :cards="cards" :loading="loadingCards" @cardSelecionado="cardSelecionado = $event" />
      </v-flex>
    </v-layout>

    <v-layout wrap :fill-height="true">
      <v-flex xs12 v-if="cardSelecionado" style="padding: 0 2% 2% 2%;">
        <ListaProdutos v-if="cardSelecionado.key === 'card-produtos'" />
        <Departamentos v-else-if="cardSelecionado.key === 'card-departamentos'" />
        <PedidosPendentes v-else-if="cardSelecionado.key === 'card-pedidos-pendentes'" />
        <Table v-else :cardSelecionado="cardSelecionado" :cards="cards" @cardSelecionado="cardSelecionado = $event" />
      </v-flex>
    </v-layout>
  </v-app>
</template>
<script>
import NewChart from "./ChartMovimentacoes";
import Cards from "./CardsTotais";
import Table from "./TabelaItensCards";
import DashboardAPI from "./../../api/dashboard";
import VueLazyInput from "vue-lazy-input";
import Vue from "vue";
import { mapGetters } from "vuex";
import ListaProdutos from "./produtos/Index";
import Departamentos from "./departamentos/Index";
import PedidosPendentes from "./PedidosPendentes/Index.vue";

Vue.use(VueLazyInput);

export default {
  components: {
    NewChart,
    Cards,
    Table,
    ListaProdutos,
    Departamentos,
    PedidosPendentes
  },
  data() {
    return {
      cards: {
        fornecedores: {
          titulo: "Análise de Fornecedores",
          ativo: false,
          item_key: "id",
          exibir_selecao: localStorage.ativar_grupo_economico_compra === 'S',
          headers: [
            //HEADER ESTOQUE
            [
              { text: "Código", value: "id"  },
              { text: "Razão Social", value: "razao_social" },
              { text: "Qtde. Produtos Total", value: "qtde_geral_itens"  },
              { text: "Produtos Excesso", value: "qtde_itens_excesso" },
              { text: "Produtos Adequado", value: "qtde_itens_ok" },
              { text: "Produtos a Comprar", value: "qtde_itens_ressuprir" },
              { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
              { text: "Produtos em Trânsito", value: "qtde_itens_transito" },
              { text: "Total Pendente (R$ Compras)", value: "total_pendente", style: { textAlign:'end' } },
              { text: "Cob. média estoque", value: "qtde_dias_estoque" },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir"  },
              { text: "Total Estoque Atual", value: "total_estoque"  },
              { text: "", value: "icon_compra", sortable: false }
            ],
            //HEADER FINANCEIRO
            [
              { text: "Código", value: "id"  },
              { text: "Fornecedor", value: "razao_social" },
              { text: "Total Itens", value: "qtde_geral_itens"  },
              { text: "Estoque em Preço Custo", value: "total_estoque"  },
              { text: "Mark-up Médio", value: "markup_medio" },
              { text: "Estoque em Preço Venda", value: "total_estoque_venda"  },
              // { text: "Nível de Estoque", value: "nivel_estoque" },
              { text: "Média Últimos 3 meses", value: "media_venda_trimestre_anterior" },
              { text: "Projeção de vendas", value: "projecao_venda_mensal"  },
              { text: "Projeção Rentabilidade Mensal", value: "projecao_rentabilidade_mensal"  },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
              { text: "", value: "icon_compra", sortable: false },
            ],
          ],
          itens: [],
          total: 0,
          metodo: (page, grupo) => {
            this.Helpers.getFornecedoresGrupo(page, grupo);
          },
          multHeaders: true,
          url_exportacao: "/relatorios/dashboard/analise-fornecedores",
        },
        departamentos: {
          titulo: "Análise de Departamentos",
          ativo: false,
          total: 0,
          key: 'card-departamentos',
          ocultar: !(localStorage.compras_analise_por_departamentos === "true"),
        },
        categorias: {
          titulo: "Análise de Segmentos",
          ocultar: localStorage.compras_analise_por_departamentos === "true",
          ativo: false,
          item_key: "idfamilia_produto",
          headers: [
            //HEADER ESTOQUE
            [
              { text: "Código", value: "idfamilia_produto"  },
              { text: "Segmentos", value: "descricao_familia_produto" },
              { text: "Qtde. Fornecedores", value: "qtde_fornecedores"  },
              { text: "Qtde. Produtos Total", value: "qtde_geral_itens"  },
              { text: "Produtos Excesso", value: "qtde_itens_excesso"  },
              { text: "Produtos Adequado", value: "qtde_itens_ok"  },
              { text: "Produtos a Comprar", value: "qtde_itens_ressuprir"  },
              { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
              { text: "Produtos em Trânsito", value: "qtde_itens_transito"  },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir"  },
              { text: "Total Estoque Atual", value: "total_estoque"  },
              { text: "", value: "icon_analise_segmentos", sortable: false }
            ],
            //HEADER FINANCEIRO
            [
              { text: "Código", value: "idfamilia_produto" },
              { text: "Segmentos", value: "descricao_familia_produto" },
              { text: "Qtde. Fornecedores", value: "qtde_fornecedores" },
              { text: "Total Itens", value: "qtde_geral_itens" },
              { text: "Estoque em Preço Custo", value: "total_estoque" },
              { text: "Mark-up Médio", value: "markup_medio" },
              { text: "Estoque em Preço Venda", value: "total_estoque_venda"},
              // { text: "Nível de Estoque", value: "nivel_estoque" },
              { text: "Média Últimos 3 meses", value: "media_venda_trimestre_anterior" },
              { text: "Projeção de vendas", value: "projecao_venda_mensal" },
              { text: "Projeção Rentabilidade Mensal", value: "projecao_rentabilidade_mensal" },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
              { text: "", value: "icon_analise_segmentos", sortable: false },
            ]
          ],
          itens: [],
          total: 0,
          metodo: (page, grupo) => {
            this.Helpers.getCategoriasGrupo(page, grupo);
          },
          multHeaders: true,
          url_exportacao: '/relatorios/dashboard/analise-segmentos'
        },
        compradores: {
          titulo: "Análise de Compradores",
          ativo: false,
          item_key: "index",
          headers: [
            //HEADER ESTOQUE
            [
              { text: "Código", value: "id" },
              { text: "Nome Completo", value: "nome_completo" },
              { text: "Qtde. Fornecedores", value: "qtde_fornecedores" },
              { text: "Qtde. Produtos Total", value: "qtde_geral_itens"  },
              { text: "Produtos Excesso", value: "qtde_itens_excesso" },
              { text: "Produtos Adequado", value: "qtde_itens_ok" },
              { text: "Produtos a Comprar", value: "qtde_itens_ressuprir" },
              { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
              { text: "Produtos em Trânsito", value: "qtde_itens_transito" },
              { text: "Eficiência Mês Atual", value: "eficiencia" },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
              { text: "Total Estoque Atual", value: "total_estoque" },
              { text: "Ações", value: "icon_analise", sortable: false }
            ],
            //HEADER FINANCEIRO
            [
              { text: "Código", value: "id" },
              { text: "Nome Completo", value: "nome_completo" },
              { text: "Qtde. Fornecedores", value: "qtde_fornecedores"  },
              { text: "Total Itens", value: "qtde_geral_itens" },
              { text: "Estoque em Preço Custo", value: "total_estoque" },
              { text: "Mark-up Médio", value: "markup_medio" },
              { text: "Estoque em Preço Venda", value: "total_estoque_venda" },
              // { text: "Nível de Estoque", value: "nivel_estoque" },
              { text: "Média Últimos 3 meses", value: "media_venda_trimestre_anterior" },
              { text: "Projeção de vendas", value: "projecao_venda_mensal" },
              { text: "Projeção Rentabilidade Mensal", value: "projecao_rentabilidade_mensal" },
              { text: "Eficiência Mês Atual", value: "eficiencia" },
              { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
              { text: "Ações", value: "icon_analise", sortable: false },
            ],
          ],
          itens: [],
          total: 0,
          metodo: (page, grupo) => {
            this.Helpers.getCompradoresGrupo(page, grupo);
          },
          multHeaders: true,
          url_exportacao: '/relatorios/dashboard/analise-compradores'
        },
        // pedidos: {
        //   titulo: "Pedidos em Trânsito",
        //   ativo: false,
        //   item_key: "index",
        //   headers: [
        //     [
        //       { text: "Nº Pedido", value: "id_solicitacao" },
        //       { text: "Data Solicitação", value: "data_solicitacao" },
        //       { text: "Data Previsão", value: "data_previsao" },
        //       { text: "Cód. Fornecedor", value: "id" },
        //       { text: "Fornecedor", value: "razao_social" },
        //       { text: "Qtde. Itens", value: "qtde_itens" },
        //       { text: "Qtde. Pendentes", value: "qtde_itens_pendentes" },
        //       { text: "(R$) Total Pedido", value: "total_itens" },
        //       { text: "", value: "icon_eye", sortable: false },
        //     ]
        //   ],
        //   itens: [],
        //   total: 0,
        //   metodo: (page, grupo) => {
        //     this.Helpers.getPedidosGrupo(page, grupo);
        //   },
        //   multHeaders: false,
        //   url_exportacao: '/relatorios/dashboard/analise-pedidos-em-transito'
        // },
        pedidosPendentes: {
          titulo: "Pedidos Pendentes",
          ativo: false,
          key: 'card-pedidos-pendentes',
          total: 0,
          multHeaders: false
        },
        produtos: {
          titulo: "Produtos",
          ativo: false,
          key: 'card-produtos',
          total: 0,
          multHeaders: false
        },
        produtosComprar: {
          titulo: "Produtos a comprar",
          ativo: false,
          headers: [[]],
          itens: [],
          total: 0,
          multHeaders: false
        },
      },
      cardSelecionado: null,
      loadingCards: null
    }
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    })
  },
  watch: {
    grupoCompra: function () {
      this.buscarTotais();
    },
  },
  created() {
    this.Helpers.verificarToken();
    this.buscarTotais();
  },
  methods: {
    buscarTotais() {
      this.loadingCards = true
      const comprador = this.$store.getters['usuario/getComprador'];

      const params = {
        idcomprador: comprador.id ? comprador.id : 0
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getTotaisGrupo(this.grupoCompra, params)
          .then((response) => {
            const totais = response.data.totais || {};

            this.cards.fornecedores.total = totais.qtd_fornecedores || 0;
            this.cards.categorias.total = totais.qtd_categorias || 0;
            this.cards.departamentos.total = totais.qtd_departamentos || 0;
            this.cards.compradores.total = totais.qtd_compradores  || 0;
            this.cards.pedidosPendentes.total = totais.qtd_requisicoes_em_aberto || 0;
            this.cards.produtos.total = totais.qtd_produtos || 0;
            this.cards.produtosComprar.total = totais.qtd_produtos_comprar || 0;
            this.loadingCards = false
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>
<style scoped>
.app-dashboard {
  background-color: #042333;
  height: 150px;
}

.card-chart {
  border-radius: 5px;
  height: 230px;
}

.div-main-chart {
  padding: 0.5% 2% 1% 2%;
}
</style>
